import { useEffect, useState } from 'react'

function FaceFrown({fill}){

  const [colorFill, setColorFill] = useState(getComputedStyle(document.documentElement).getPropertyValue('--bs-primary'))

  useEffect(() => {
    if (fill === 'danger') {
      setColorFill(getComputedStyle(document.documentElement).getPropertyValue('--bs-danger'))
    }
    else if (fill === 'success') {
      setColorFill(getComputedStyle(document.documentElement).getPropertyValue('--bs-success'))
    }

  }, [fill])

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 512 512">
      <path
        fill={colorFill}
        d="M256 351.1C218.8 351.1 192.8 369.5 177.6 385.9C168.7 395.6 153.5 396.3 143.7 387.3C133.1 378.3 133.4 363.1 142.4 353.4C164.3 329.5 202.3 303.1 256 303.1C309.7 303.1 347.7 329.5 369.6 353.4C378.6 363.1 378 378.3 368.3 387.3C358.5 396.3 343.3 395.6 334.4 385.9C319.2 369.5 293.2 351.1 256 351.1V351.1zM208.4 208C208.4 225.7 194 240 176.4 240C158.7 240 144.4 225.7 144.4 208C144.4 190.3 158.7 176 176.4 176C194 176 208.4 190.3 208.4 208zM304.4 208C304.4 190.3 318.7 176 336.4 176C354 176 368.4 190.3 368.4 208C368.4 225.7 354 240 336.4 240C318.7 240 304.4 225.7 304.4 208zM512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256zM256 48C141.1 48 48 141.1 48 256C48 370.9 141.1 464 256 464C370.9 464 464 370.9 464 256C464 141.1 370.9 48 256 48z"/>
    </svg>
  )
}
export default FaceFrown;